
class Tests {

  /**
   * @param {Request} request
   * @param {Tenants} tenants
   * @param {HealthSafety} healthSafety
   */
  constructor(request, tenants, healthSafety) {
    this.request = request;
    this.tenants = tenants;
    this.healthSafety = healthSafety;
    this.logTagStyle = 'color:#44eb70;'
    this.logNameStyle = 'color:#ff9900;'
  }

  logTest(name, result) {
    console.log('%c[ TEST ] %c' + name, this.logTagStyle, this.logNameStyle, result);
  }

  test() {
    (async () => {
      this.logTest('tenants.get()', await this.tenants.get());
      this.logTest('tenants.getCurrent()', await this.tenants.getCurrent());

      this.logTest('request/ping', await this.request.request('ping'));
      this.logTest('request/validate', await this.request.request('validate'));
    })();
  }

  testHealthSafety() {
    (async () => {
      this.logTest('health-safety/hazards', await this.healthSafety.getHazards());
      this.logTest('health-safety/employees', await this.healthSafety.getEmployees());
      this.logTest('health-safety/equipment-types', await this.healthSafety.getEquipmentTypes());
      this.logTest('health-safety/material-types', await this.healthSafety.getMaterialTypes());
      this.logTest('health-safety/reports', await this.healthSafety.getReports());
      this.logTest('health-safety/reports/1', await this.healthSafety.getReport(1));
    })();
  }

  testHealthSafetyCreate() {
    (async () => {
      this.logTest('POST health-safety/reports', await this.healthSafety.postReport({
        'description': 'Test Description'
      }));
      this.logTest('PATCH health-safety/reports', await this.healthSafety.patchReport(2, {
        'description': 'Test Description'
      }));
    })();
  }

  testHealthSafetyManager() {
    (async () => {
      this.logTest('health-safety/manager/reports', await this.healthSafety.getManagerReports());
      this.logTest('health-safety/manager/reports/1', await this.healthSafety.getManagerReport(2));
    })();
  }

  testHealthSafetyManagerPatch() {
    (async () => {
      this.logTest('PATCH health-safety/manager/reports', await this.healthSafety.patchManagerReport(2, {
        'managerNotes': 'These are the manager notes'
      }));
    })();
  }

  testHealthSafetyUpload() {
    (async () => {
      // Create a mock file
      const mockFile = new File(
        ["Hello, this is a test file content"], // File content as a Blob or string
        "test-file.txt", // File name
        { type: "text/plain" } // MIME type
      );

      this.logTest('POST health-safety/reports/upload-file', await this.healthSafety.postReportFile(2, mockFile));
    })();
  }

}

export default Tests;